import apiClient from "../../../utils/apiClient";
import { useResource } from "../../Students/StudentProfile/useStudentRecord";

/** More course-level files than this and the tabs say they show the newest. */
export const FILE_LIMIT = 200;

/**
 * Everything the course page reads up front, fetched in parallel.
 *
 * Only `course` is required to render. Each of the others fails on its own and
 * costs the page one figure, never the page.
 *
 * The files are read HERE rather than by the Videos and Materials tabs because
 * a tab's body does not mount until it is opened — and a count that appears
 * only after you look is not a count. One request serves both tabs.
 */
export default function useCourseDetails(courseId) {
  const course = useResource(courseId, () =>
    apiClient.get(`/courses/${courseId}`).then((r) => r.data.course || null));
  const batches = useResource(courseId, () =>
    apiClient.get("/batches/list", { params: { course: courseId, page: 1, pageSize: 1000 } })
      .then((r) => r.data.batches || []));
  // A course with no syllabus answers 404; that is "none", not a failure.
  const syllabus = useResource(courseId, () =>
    apiClient.get(`/syllabus/template/${courseId}`).then(
      (r) => r.data?.template || null,
      (err) => (err?.response?.status === 404 ? null : Promise.reject(err)),
    ));
  const headcount = useResource(courseId, () =>
    apiClient.get(`/courses/${courseId}/headcount`).then((r) => r.data.headcount || null));
  const files = useResource(courseId, () =>
    apiClient.get(`/materials/course/${courseId}`, { params: { page: 1, limit: FILE_LIMIT } })
      .then((r) => ({ list: r.data.data || [], total: r.data.pagination?.total ?? (r.data.data || []).length })));

  return { course, batches, syllabus, headcount, files };
}
